var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagType,_vm._g(_vm._b({tag:"component",class:`cv-header-name ${_vm.carbonPrefix}--header__name`},'component',_vm.linkProps,false),_vm.$listeners),[(_vm.prefix)?_c('span',{class:`${_vm.carbonPrefix}--header__name--prefix`},[_vm._v(_vm._s(_vm.prefix)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }